import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#141329',
        padding: '48px 0 88px 0',
        [theme.breakpoints.down('md')]: {
            padding: '0px !important',
        },
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            width: '100%',
            overflow: 'hidden',
        }
        // maxWidth: '1366px',
    },
    ctnLeft: {
        [theme.breakpoints.up('lg')]: {
            width: '50%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            marginLeft: 96
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            padding: '0',
        }
    },
    leftWrapper: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 660,
        [theme.breakpoints.up('lg')]: {
            alignItems: 'flex-start',
        },
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            padding: '0 0px',
        }
    },
    title1: {
        margin: 0,
        fontSize: 48,
        fontWeight: 800,
        color: '#fff',
        lineHeight: '58px',
        [theme.breakpoints.down('md')]: {

            textAlign: 'center',
            fontSize: 30,
            lineHeight: '36px',
            maxWidth: 400
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: 320,
        }
    },
    title2: {

        fontSize: 48,
        fontWeight: 900,
        background: 'linear-gradient(to right, #1B7AED 0%, #9048D8 66%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        textFillColor: 'transparent',
        [theme.breakpoints.down('md')]: {
            textAlign: 'center',
            fontSize: 30,
        }
    },
    ctnRight: {
        [theme.breakpoints.up('lg')]: {
            width: '40%',
            display: 'flex',
            justifyContent: 'flex-end',
        },
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
        [theme.breakpoints.down('md')]: {
            padding: '0 24px',
            width: '100%',
        }

    },
    tabContainer: {
        marginTop: 24,
        marginBottom: 40,
        [theme.breakpoints.down('md')]: {
            width: '100%',
            padding: '0 24px',
            overflow: 'auto',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            marginBottom: 24,
            paddingRight: 24
        }
    },
    ctnTab: {
        background: '#18181B',
        padding: 12,
        borderRadius: 12,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            // maxWidth: 470,
            margin: '0 auto',
        },
        [theme.breakpoints.down('sm')]: {
            width: 'max-content',
            minWidth: '100%',
            justifyContent: 'flex-start',
            padding: '12px 16px',
            whiteSpace: 'nowrap',
            WebkitOverflowScrolling: 'touch',
            scrollBehavior: 'smooth',
            paddingRight: 0
        }
    },
    tabItem: {
        cursor: 'pointer',
        height: 44,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 20px',
        borderRadius: 12,
        flexShrink: 0,
        '&:not(:nth-last-child(-n+2))': {
            marginRight: 32
        },
        '&:hover': {
            background: '#403DE3'
        },
        '& > span': {
            fontSize: 16,
            fontWeight: 800,
            color: '#fff',
        },
        [theme.breakpoints.down('md')]: {
            '&:not(:nth-last-child(-n+2))': {
                marginRight: 16
            },
            padding: '0 16px',
            flexShrink: 0,
        },
        [theme.breakpoints.down(1400)]: {
            '&:not(:nth-last-child(-n+2))': {
                marginRight: 16
            },
        },
        [theme.breakpoints.down(400)]: {
            '&:not(:nth-last-child(-n+2))': {
                marginRight: 4
            },
        }
    },
    active: {
        background: '#403DE3'
    },
    desktopImage: {
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'block',
        }
    },
    mobileImage: {
        display: 'block',
        maxWidth: 380,
        margin: '0 auto',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        }
    },
    ctnButtonDesktop: {
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'block',
        }
    },
    ctnButtonMobile: {
        display: 'block',
        paddingTop: 24,
        width: '100%',
        '& > button': {
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
        [theme.breakpoints.down('md')]: {
            paddingTop: 32,
            paddingBottom: 52
        },
        [theme.breakpoints.down('xs')]: {
            '& > button': {
                width: '100%',
            }
        }
    },
    ctnTabMobile: {
        width: 20,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& > span': {
            fontSize: 16,
            fontWeight: 800,
            color: '#fff',
        },
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        }
    }
}));

export default useStyles;